import React, { useEffect } from 'react';
import Navbar from './Components/Navbar'; // Adjust path as needed
import Footer from '../Components/Footer'; // Adjust path as needed
import Policy from './Components/Policy';

const RefundPolicy = () => {
    useEffect(()=>{
        window.scrollTo(0,0)
    })
  const refundContent = [
    "At Elaichi & Love, each of our products is freshly prepared using premium ingredients, made specially to order. Because of this, we do not accept returns or offer refunds, except in rare circumstances.",
    "If your order arrives damaged or contains a defect, please contact us within 1 hour of delivery. Our team will assess the situation and determine whether a replacement or refund is warranted.",
    "We may request photographs to help us evaluate the issue accurately.",
    "Please note that we are unable to offer refunds or replacements for items that have been partially or fully consumed, or if damage is reported after the 1-hour window.",
    "Since taste is inherently personal, we do not offer refunds for preferences related to flavour or texture unless it's due to a product fault.",
    "In select cases, we may choose to provide a goodwill refund or replacement if we believe it aligns with our commitment to customer satisfaction and brand standards.",
    "However, we retain the right to decline any request that does not meet the outlined conditions.",
    "We appreciate your understanding and thank you for choosing Elaichi & Love."
  ];

  return (
    <div className="page-container">
      <Navbar />
      <Policy title="Return & Refund Policy" content={refundContent} />
      <Footer />
    </div>
  );
};

export default RefundPolicy;
